import { Fragment, h } from "preact";
import { memo } from "react";
import { compareRender } from "../../../functions/form";
import { Input as InputAntd, Row } from "antd";
import { Required, RowComponent } from "../../../style/styled";
import { useController } from "react-hook-form";
import { Text } from "../../text";

interface IProps {
  control: any;
  item: any;
  handleChange: any;
}

const LinkUrl = ({ control, item, handleChange }: IProps) => {
  const {
    ref,
    rules,
    name,
    defaultValue,
    label,
    disabled,
    placeholder,
    inputStyle,
  } = item;

  const { field, fieldState } = useController({
    control,
    name,
    rules,
    defaultValue,
  });
  const { error } = fieldState;
  const { value } = field;

  return (
    <>
      <RowComponent>
        {label && <Text size={"XS"} text={label} bold={true} />}
        {rules && rules.required && <Required>*</Required>}
      </RowComponent>

      {value ? (
        <a href={value} target="_bank">
          {value}
        </a>
      ) : (
        <InputAntd
          id={ref}
          name={ref}
          value={value}
          disabled={disabled}
          onChange={(e) => handleChange(e, item)}
          placeholder={placeholder}
          autoComplete={"off"}
          style={inputStyle}
        />
      )}
      <Row>
        {error &&
          ((
            <Text size={"XS"} text={error.message} color="red" bold />
          ) as React.ReactNode)}
      </Row>
    </>
  );
};

export const MemoizedLinkUrl = memo(
  LinkUrl,
  (prev: any, next: any) =>
    compareRender(prev, next) &&
    JSON.parse(JSON.stringify(prev.item)) ===
      JSON.parse(JSON.stringify(next.item))
);
